/// <reference path="appbase.ts" />

namespace TerminalApp {
    class PickListElement {
        index: number = 0;
        data: SP.PickListInfo;
        html: HTMLElement;
        menu: SP.SwipeMenu;

        text_name: HTMLElement;
        text_date: HTMLElement;
        text_location: HTMLElement;
        text_description: HTMLElement;
        text_icon: HTMLImageElement;

        occupant_info: HTMLElement;


        constructor(data: SP.PickListInfo) {
            this.data = data;

            this.html = CreateButton("/terminal/img/icon/list2.png", null);
            this.html.classList.add("full");
            this.html.style.height = "88px";


            if (!data.pickListActive) {
                this.html.classList.add("disabled");
                this.html.addEventListener("click", () => { GetApp("app_picklist").open({ id: this.data.pickListId }) });
            }
            else {
                this.menu = new SP.SwipeMenu(
                    /*Element*/
                    this.html,

                    /*Click Event*/
                    async () => {
                        if (this.data.occupantUserName && !(await SP.confirmX("Overtake control from " + this.data.occupantUserName))) return;

                        GetApp("app_picklist").open({ id: this.data.pickListId });
                    },

                    /*buttons*/
                    [
                    /*Cancel Button*/{
                            icon: "<i class='fas fa-trash'></i>", text: SP.Localize("word_cancel"), color: "#e83535", confirm: true, action: async () => {
                                StartLoading();
                                var result = await SP.get<any>("/api/v1/picklist/cancel/" + this.data.pickListId);
                                console.log(result);
                                if (result.status == 200) {
                                    SP.Sounds.Success.play();
                                    this.menu.return();
                                    this.html.remove();
                                    this.menu.remove();
                                }
                                else {
                                    SP.Sounds.Error.play();
                                    this.menu.return();
                                    await SP.alertX(`${result.status}: ${result.msg}`);
                                    if (result.exception) { console.log(result.exception); }
                                }
                                StopLoading();
                            }
                        }
                    ],
                    /*group*/
                    "app_pick_orders"
                );
            }

            this.updateText();



        }



        updateText() {
            //clear
            this.html.innerHTML = "";

            var inner = this.html.appendChild(document.createElement("div"));

            //icon
            this.text_icon = inner.appendChild(document.createElement("img"));
            this.text_icon.classList.add("icon");
            this.text_icon.src = "/terminal/img/icon/list2.png";

            //date/user text
            this.text_date = inner.appendChild(document.createElement("div"));
            this.text_date.classList.add("text", "bottom", "right", "small");
            this.text_date.innerHTML = `${this.data.createUserName} <span class='bold'>${this.data.pickListDate}</span> ${this.data.pickListTime}`;

            //name
            this.text_name = inner.appendChild(document.createElement("div"));
            this.text_name.classList.add("text", "top", "big", "left");
            this.text_name.style.right = "55px";
            this.text_name.innerHTML = `<span class="label">${this.data.pickedCount} / ${this.data.pickCount}</span> ${this.data.stockName} #${this.data.pickListId}<br /><small>${this.data.pickSettings?.name ?? ""}</small>`;

            //date/user name
            this.text_description = inner.appendChild(document.createElement("div"));
            this.text_description.classList.add("text", "left", "small");
            this.text_description.style.lineHeight = "16px";
            this.text_description.innerHTML = `<span class="bold">${this.data.pickLinesCount + " " + SP.Localize("word_locations")}</span>`;

            //date/user name
            this.text_location = inner.appendChild(document.createElement("div"));
            this.text_location.classList.add("text", "top", "right");
            this.text_location.innerHTML = `<span class="label">${Math.round(this.data.pickListRouteLength)} m</span>`;

            if (this.data.pickListAttention) {
                var icon = inner.appendChild(document.createElement("div"));
                icon.classList.add("attention");
                icon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
            }



            inner.style.opacity = this.data.occupantUserName ? "0.5" : "1";
            //this.html.style.pointerEvents = this.data.occupantUserName ? "none" : "all";
            this.html.style.backgroundColor = this.data.occupantUserName ? "rgba(255,255,255,0.3)" : "#fff";

            if (this.data.occupantUserName) {

                if (!this.occupant_info) {
                    this.occupant_info = document.createElement("div");
                    this.occupant_info.classList.add("occupant_info");
                }
                this.occupant_info.innerHTML = this.data.occupantUserName;
                this.html.appendChild(this.occupant_info);
            }
        }
    }


    export class App_Pick_Orders extends AppBase {
        pickLists: { [id: string]: PickListElement } = {};
        finished_pickLists: SP.PickListInfo[] = [];
        active = document.getElementById("pick_orders_active_lists");
        finished = document.getElementById("pick_orders_finished_lists");
        pick_orders_generate_button = document.getElementById("pick_orders_generate_button");

        constructor() {
            super("app_pick_orders");
            hub.on("pickListAdded", (d) => this.pickListAdded(d));
            hub.on("pickListUpdated", (d) => this.pickListUpdated(d));


            this.pick_orders_generate_button.addEventListener("click", () => {
                GetApp("app_generate_picklist").open();
            });


            hub.on("picklistUpdated", (d) => this.pickListUpdated(d));
            hub.on("picklistAdded", (d) => this.pickListAdded(d));
            hub.on("picklistDeleted", (d) => this.picklistDeleted(d));
        }



        PicklistDelete(data: SP.PickListInfo) {

        }

        bound = false;
        async onOpen() {
            //reset
            this.pickLists = {};
            this.active.innerHTML = "";
            this.additionalCount = 0;
            if (this.showAllButton) this.showAllButton.style.display = "none";

            //load
            var activePickLists = await SP.Data.PickList.getPickListInfos();
            activePickLists.forEach((a) => {
                this.pickListAdded(a);
            });

            //load finished data
            this.finished_pickLists = await SP.Data.PickList.getFinishedPickListInfos();


            //bind events and groups
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("t", this.scanTote, this);
            }
        }


 

        async onClose() {


            //unbind events and groups
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("t", this.scanTote);
            }
 
        }

        async scanTote(toteid: string) {
            var result = await SP.Data.PickList.getPickListInfoFromTote(parseInt(toteid));
            if (result != null) {
                SP.setAllHash({ "app": "app_picklist", "id": result.pickListId.toString() });
            }
            else {
                SP.Sounds.Error.play();
            }
            console.log(toteid, result);
        }

        showAllButton: HTMLElement;
        showAllButtonLabel: HTMLElement;
        additionalCount = 0;

        pickListAdded(data: SP.PickListInfo) {
            var current = this.pickLists[data.pickListId];
            if (current == null) {
                current = this.pickLists[data.pickListId] = new PickListElement(data);
                this.active.appendChild(current.html);

                if (App_Settings.wmsSettings.fulfillment_location != 'global' && data.pickSettings?.fulfillmentLocation != App_Settings.wmsSettings.fulfillment_location) {
                    current.html.style.display = "none";

                    if (!this.showAllButton) {
                        this.showAllButton = this.active.appendChild(createListButton("profile_list_button", SP.Localize("sentance_other_fulfillment_locations"), async () => {
                            if (await SP.confirmX(SP.Localize("word_show") + ' ' + SP.Localize("sentance_other_fulfillment_locations") + '?')) {
                                //show all hidden buttons and hide this
                                for (var id in this.pickLists) {
                                    this.pickLists[id].html.style.display = "flex";
                                }
                                this.showAllButton.style.display = "none";
                            }
                        }));
                        this.showAllButton.style.display = "none";
                        this.showAllButton.style.backgroundColor = "#cfcfcf";
                        var label = this.showAllButtonLabel = this.showAllButton.appendChild(document.createElement("span"));
                        label.classList.add("label");
                    }
                    this.active.appendChild(this.showAllButton);
                    this.additionalCount++;

                    this.showAllButtonLabel.innerHTML = this.additionalCount.toString();
                    this.showAllButton.style.display = "flex";


                }
            }
        }

        pickListUpdated(data: SP.PickListInfo) {
            if (!data.pickListActive) {
                this.finished_pickLists.push(data);
                this.picklistDeleted(data);
                return;
            }

            var current = this.pickLists[data.pickListId];
            if (current != null) {
                current.data = data;
                current.updateText();
            }
        }

        picklistDeleted(data: SP.PickListInfo) {
            var current = this.pickLists[data.pickListId];
            if (current != null) {
                current.menu.remove();
                current.html.remove();
            }
        }


    }
    RegisterApp("app_pick_orders", App_Pick_Orders);
}